import $$ from 'cmn-utils'

const baseUrl = "/api/sys/area/v2/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    // get: (params) => {
    //     return $$.get(baseUrl + 'get', params)
    // },
    listMap: (params) => {
        return $$.get(baseUrl + 'list-map', params)
    },
    tree: (params) => {
        return $$.get(baseUrl + 'tree', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },

}

